import { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { Radio, Input, Space, message } from 'antd';
import './index.less';
import { useLocation } from 'react-router-dom';
import { timesaveTemplateQuestionApi } from '@services/Wj/Template';
import { timesaveSurveryQuestionApi } from '@services/Wj/Question';
import RichEditor from '@components/common/RichEditor';
import { useSurveyAutosave } from '../../SurveyAutosaveContext';
import { applyQuestionStemFocusBorder, clearQuestionStemFocusBorder } from '../richEditorFocusHelpers';
import { useQuestionStemAutosave } from '../useQuestionStemAutosave';
import { saveQuestionStemBody } from '../saveQuestionStemBody';

const Judge = ({ questionId, item, setAnserArea, anserArea, onReset }) => {
    const { notifySaved } = useSurveyAutosave();
    const [questionIndex, setQuestionIndex] = useState();
    const [choiceList, setChoiceList] = useState([]);
    const [titleBorder, setTitleBorder] = useState(false);
    const [titleIn, setTitleIn] = useState(false);
    const [bodyHtml, setBodyHtml] = useState(item.body);
    const { TextArea } = Input;
    const location = useLocation();
    const { pathname } = location;
    const editorRootRef = useRef(null);
    const anserAreaRef = useRef(anserArea);

    useEffect(() => {
        anserAreaRef.current = anserArea;
    }, [anserArea]);

    useEffect(() => {
        setBodyHtml(item.body);
    }, [item.body]);

    useEffect(() => {
        const index = anserArea.findIndex(it => it.id === item.id);
        setQuestionIndex(index + 1);
    }, [anserArea, item.id]);

    useEffect(() => {
        setChoiceList([...(item.options || [])]);
    }, [item.options]);

    const onPersist = useCallback(
        async nextBody => {
            const ok = await saveQuestionStemBody({
                item,
                nextBody,
                anserArea: anserAreaRef.current,
                locationState: location.state,
                pathname,
            });
            if (ok) {
                notifySaved();
            }
            return ok;
        },
        [item, location.state, pathname, notifySaved],
    );

    const { schedule, flush } = useQuestionStemAutosave({
        itemId: item.id,
        remoteBody: item.body,
        onPersist,
    });

    const handleStemChange = useCallback(
        html => {
            setBodyHtml(html);
            schedule(html);
        },
        [schedule],
    );

    const changeTitle = (_editor, latestHtml) => {
        const nextBody = latestHtml != null ? latestHtml : bodyHtml;
        const root = editorRootRef.current;
        if (root) {
            clearQuestionStemFocusBorder(root);
        }
        setBodyHtml(nextBody);
        setTitleBorder(false);
        flush(nextBody);
    };

    const getBorder = () => {
        const root = editorRootRef.current;
        if (root) {
            applyQuestionStemFocusBorder(root);
        }
        setTitleBorder(true);
        setTitleIn(true);
    };

    const changeOpinion = (e, it) => {
        it.content = e.target.value;
        if (choiceList[0].content === '') {
            choiceList[0].content = '对';
        } else if (choiceList[1].content === '') {
            choiceList[1].content = '错';
        }
        setChoiceList([...choiceList]);
        saveOpinion();
    };

    const saveOpinion = sortArr => {
        const resArr = [...anserArea];
        const index = resArr.findIndex(it => it.id === item.id);
        resArr[index] = {
            ...resArr[index],
            templateId: location.state.id,
            options: sortArr || choiceList,
        };
        if (location.state.route === 'newCreate') {
            timesaveTemplateQuestionApi(resArr[index]).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                    onReset();
                }
            });
        } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
            timesaveSurveryQuestionApi(resArr[index]).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                    onReset();
                }
            });
        }
        setAnserArea(resArr);
    };

    return (
        <Fragment>
            <div name={questionId}>
                <div className="question-title">
                    <div className="question-id">
                        <span
                            className="required"
                            style={{
                                display: item.required === 1 ? '' : 'none',
                            }}
                        >
                            *
                        </span>
                        <b className="question-index">{questionIndex}.</b>
                    </div>
                    <div ref={editorRootRef}>
                        <RichEditor id={`wj-judge-question-${item.id}`} mode="simple" inline value={bodyHtml} onChange={handleStemChange} placeholder="请输入问题" className="question-title-area" height={128} onEditorFocus={getBorder} onEditorBlur={changeTitle} />
                    </div>
                </div>
                <Radio.Group className="judge-option">
                    <Space orientation="vertical">
                        <Radio key={item.options[0]?.id} value={item.options[0]?.id} disabled>
                            <TextArea
                                className="option-item"
                                placeholder={`对`}
                                defaultValue={item.options[0]?.content}
                                onBlur={e => changeOpinion(e, item.options[0], 0)}
                                variant="borderless"
                                maxLength={200}
                                autoSize={{
                                    minRows: 1,
                                }}
                            ></TextArea>
                        </Radio>
                        <Radio key={item.options[1]?.id} value={item.options[1]?.id} disabled>
                            <TextArea
                                className="option-item"
                                placeholder={`错`}
                                defaultValue={item.options[1]?.content}
                                onBlur={e => changeOpinion(e, item.options[1])}
                                variant="borderless"
                                maxLength={200}
                                autoSize={{
                                    minRows: 1,
                                }}
                            ></TextArea>
                        </Radio>
                    </Space>
                </Radio.Group>
            </div>
        </Fragment>
    );
};

export default Judge;
